"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REQUEST_DELETE_ACCOUNT = exports.GET_OLD_TOKEN_DETAILS = exports.GET_LOGIN_TYPE = exports.GET_EMAIL_DATA = exports.GET_COUNTRY_FLAGS_DATA = exports.GET_ACCESS_TOKEN = exports.DELETE_ACCOUNT = exports.CHECK_USER_EXIST = exports.CHECK_EMAIL_EXIST = exports.BIOMETRIC_TOKEN = void 0;
const GET_ACCESS_TOKEN = exports.GET_ACCESS_TOKEN = 'getAccessToken';
const CHECK_USER_EXIST = exports.CHECK_USER_EXIST = 'checkUserExist';
const CHECK_EMAIL_EXIST = exports.CHECK_EMAIL_EXIST = 'checkEmailExist';
const GET_EMAIL_DATA = exports.GET_EMAIL_DATA = 'getEmailData';
const REQUEST_DELETE_ACCOUNT = exports.REQUEST_DELETE_ACCOUNT = 'requestDeleteAccount';
const DELETE_ACCOUNT = exports.DELETE_ACCOUNT = 'deleteAccount';
const GET_COUNTRY_FLAGS_DATA = exports.GET_COUNTRY_FLAGS_DATA = 'getCountryFlagsData';
const BIOMETRIC_TOKEN = exports.BIOMETRIC_TOKEN = 'biometricToken';
const GET_LOGIN_TYPE = exports.GET_LOGIN_TYPE = 'getLoginType';
const GET_OLD_TOKEN_DETAILS = exports.GET_OLD_TOKEN_DETAILS = 'getOldTokenDetails';